import Alpine from "alpinejs";
import collapse from "@alpinejs/collapse";

import { initSmoothScroll } from "./scripts/smooth-scroll.js";
import { revealOnScroll } from "./scripts/reveal-on-scroll.js";

document.addEventListener("DOMContentLoaded", () => {
  initSmoothScroll();
  revealOnScroll();
});

Alpine.plugin(collapse);
window.Alpine = Alpine;
Alpine.start();
